/* eslint-disable */
import * as types from './graphql';
const documents = {
    '\n  mutation UpdateTheme($theme: Theme!) {\n    authz_updateMySettings(theme: $theme) {\n      theme\n    }\n  }\n': types.UpdateThemeDocument,
    '\n  query authz_mySettings {\n    authz_mySettings {\n      theme\n    }\n  }\n': types.Authz_MySettingsDocument,
    '\n  mutation setIsLatestUserInterfaceEnabled(\n    $enable: Boolean!\n    $userInterface: String\n  ) {\n    setIsLatestUserInterfaceEnabled(\n      enable: $enable\n      userInterface: $userInterface\n    ) {\n      useLatestUserInterface\n    }\n  }\n': types.SetIsLatestUserInterfaceEnabledDocument,
    '\n  query isLatestUserInterfaceEnabled($userInterface: String) {\n    isLatestUserInterfaceEnabled(userInterface: $userInterface)\n  }\n': types.IsLatestUserInterfaceEnabledDocument,
};
export function graphql(source) {
    var _a;
    return (_a = documents[source]) !== null && _a !== void 0 ? _a : {};
}
